const adapter = {
  responseBodyToRender(input){
    let output = {}

    if(input){
      const {
        typeJoin,
        organisasi,
        statusRequest,
      } = input

      output = {
        type: typeJoin,
        sender: {
          id: organisasi.organisasiId,
          name: organisasi.namaOrganisasi
        },
        status: {
          id: statusRequest.id,
          name: statusRequest.nama[0]
        }
      }
    }

    return output
  },
  responseBodyToOrganizationForm(input){
    let output = {}

    if(input){
      const {
        id,
        typeJoin,
        individu,
        statusRequest,
      } = input

      output = {
        id,
        type: typeJoin,
        sender: {
          id: individu.userId,
          name: individu.namaIndividu
        },
        status: {
          id: statusRequest.id,
          name: statusRequest.nama[0]
        }
      }
    }

    return output
  }
}

export default adapter
